import { removeCookie } from "@insite/client-framework/Common/Cookies";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { deleteSession, stopWatchingForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import { clearSloSessionState, getSloConfig, removeSloSignInCookie } from "@thkStore/Common/Utils/SloService";

type HandlerType = Handler;

export const DeleteSloCookie: HandlerType = async () => {
    clearSloSessionState();
    const config = await getSloConfig();
    if (config.enabled && config.cookieDomain) {
        removeSloSignInCookie(config.cookieDomain);
    }
};

export const DeleteSession: HandlerType = () => {
    stopWatchingForOtherTabSessionChange();
    removeCookie("NavigationMode");
    return deleteSession();
};

export const CloseAzureSession: HandlerType = () => {
    return fetch('/api/v1/logout?returnUrl=/', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`Logout failed with status ${response.status}: ${response.statusText}`);
        }
        return response.json();
    })
    .then((data: { redirected: boolean; url: string }) => {
        window.location.href = data.url || '/';
    })
    .catch(error => {
        console.error('[THK SSO Logout] Error during logout:', error);
        window.location.href = '/';
    });
}

export const chain = [DeleteSloCookie, DeleteSession, CloseAzureSession];

const signOut = createHandlerChainRunnerOptionalParameter(chain, {}, "SignOut");
export default signOut;
